import React from "react";

function AppFormError({ error, visible }) {
  if (!error | !visible) return null;

  return <span className="text-danger">{error}</span>;
}

export default AppFormError;
